import React, { useRef, useState } from "react";
import LazyImage from "../general/lazyImage";
import { faPaperPlane, faThumbsUp } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay, faCirclePause } from "@fortawesome/free-solid-svg-icons";
import Translate from '../general/translate';

const Audioeditsection = () => {
  const [playing, setPlaying] = useState(null);
  const audioRef = useRef(null);

  const playAudio = (url, type, currentTime) => {
    if (audioRef.current) {
      audioRef.current.pause();
    }

    if (playing === type) {
      setPlaying(null);
      return;
    }

    audioRef.current = new Audio(url);
    audioRef.current.currentTime = currentTime;
    audioRef.current.play();
    setPlaying(type);
    audioRef.current.onended = () => setPlaying(null);
  };

  return (
    <div className="md:pt-14 pt-8 pb-14 bg-[#FAFAFA]" id="audioedit">
      <div className="p-6 max-w-7xl m-auto">
        <div className="container mx-auto flex flex-col lg:flex-row items-start lg:items-center space-y-6 lg:space-y-0 lg:space-x-16">
          <div className="lg:w-1/2 flex flex-col justify-center">
            <p className="bg-[#3ADAD9] font-extrabold py-1 px-2 self-start inline-block mb-2">
              <Translate id="new.feature" foldername="home" filename="home-audioeditsection" />
            </p>
            <h2 className="text-[#27004F] text-3xl leading-tight md:text-5xl font-extrabold mt-2">
              <span className="">
                <Translate id="seamless.editing" foldername="home" filename="home-audioeditsection" />
              </span>
              <span className="text-[#643ADA]">
                <Translate id="high.quality.results" foldername="home" filename="home-audioeditsection" />
              </span>
            </h2>
            <LazyImage src="/features/repurpose-podcast-content/audio-edit-ai.webp" className="block md:hidden py-10" alt="edit podcast audio ai" />
            <p className="text-[#27004F] text-xl opacity-60 mt-0 md:mt-6">
              <Translate id="experience.audio.editing" foldername="home" filename="home-audioeditsection" />
              <a href="/remove-filler-words-from-audio/" className="font-bold">
                <Translate id="remove.ums" foldername="home" filename="home-audioeditsection" />
              </a>
              <Translate id="enhance.sound.quality" foldername="home" filename="home-audioeditsection" />
            </p>
            <a href="/squeeze" className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#483187] mt-10 font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg self-start hidden md:inline-block">
              <Translate id="enhance.audio.now" foldername="home" filename="home-audioeditsection" />
            </a>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <LazyImage src="/features/repurpose-podcast-content/audio-edit-ai.webp" className="hidden md:block" alt="edit podcast audio ai" />
          </div>
        </div>
        <div className="text-left md:text-center mb-6 mt-0 md:mt-14">
          <p className="text-[#27004F] opacity-60 text-lg">
            <Translate id="sample.audio.recorded" foldername="home" filename="home-audioeditsection" />
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-6 sm:space-y-0 sm:space-x-6 px-0 md:px-14 lg:p-6">
          <div className="bg-[#643ADA] bg-opacity-5 flex items-center justify-between p-2 rounded-full w-full sm:w-auto">
            <span className="text-[#27004F] text-lg font-bold p-4">
              <Translate id="original.recording" foldername="home" filename="home-audioeditsection" />
            </span>
            <button className="text-[#643ADA] text-6xl p-2 ml-4" onClick={() => playAudio('https://firebasestorage.googleapis.com/v0/b/podsqueeze-da0f0.appspot.com/o/static-videos%2Foriginal.mp4?alt=media&token=88d2021c-266d-4005-acf0-9f50456d4571', 'original', 1.5)}>
              <FontAwesomeIcon icon={playing === 'original' ? faCirclePause : faCirclePlay} />
            </button>
          </div>
          <div className="bg-[#643ADA] bg-opacity-5 flex items-center justify-between p-2 rounded-full w-full sm:w-auto">
            <span className="text-[#27004F] text-lg font-bold p-4 leading-tight">
              <Translate id="audio.after.ai.edit" foldername="home" filename="home-audioeditsection" />
            </span>
            <button className="text-[#643ADA] text-6xl p-2 ml-4" onClick={() => playAudio('https://firebasestorage.googleapis.com/v0/b/podsqueeze-da0f0.appspot.com/o/static-videos%2Fenhanced.mp3?alt=media&token=944f05fc-40b0-4c22-9219-57a1eb63f33e', 'enhanced', 0.9)}>
              <FontAwesomeIcon icon={playing === 'enhanced' ? faCirclePause : faCirclePlay} />
            </button>
          </div>
        </div>

        <a href="/squeeze" className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#483187] mt-10 font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg self-start inline-block md:hidden">
          <Translate id="enhance.audio.now" foldername="home" filename="home-audioeditsection" />
        </a>
      </div>
    </div>
  );
};

export default Audioeditsection;